
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
webpack.register(
    'components/clamp-text/clamp-text',
    function() {
        return require('components/clamp-text/clamp-text');
    },
    false
);
webpack.register(
    'components/svg-image/svg-image',
    function() {
        return require('components/svg-image/svg-image');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/image-universal/image-universal'/>\r\n<can-import from='components/clamp-text/clamp-text'/>\r\n<can-import from=\"components/svg-image/svg-image\" />\r\n\r\n<a href=\"{{getCardLink}}\" class=\"c-card c-card__content c-card__department c-card__department--{{card.type}}\">\r\n    <div class=\"s-title\">\r\n        <clamp-text {text}='title' lines=2 />\r\n    </div>\r\n    <div class=\"s-btn s-btn--photo\">\r\n        <svg-image image=\"sprites.svg#icon-camera\"></svg-image>\r\n    </div>\r\n    <image-universal class-name=\"s-preview__img\" {image}='image' {crop}=\"'fill'\" />\r\n    <button class=\"s-btn s-btn--play\" aria-label=\"{{getCardAriaLabel}} Play\">Play</button>\r\n</a>\r\n");